import { Grid } from '@mui/material'
import { AuthLayout } from 'components'
import { AuthWrapper } from 'containers/Auth'
import { Services } from 'containers/Services'

export const Service: React.FC = () => {
  return (
    <AuthLayout>
      <AuthWrapper>
        <Grid container>
          <Grid item>
            <Services isAuthenticated={false} />
          </Grid>
        </Grid>
      </AuthWrapper>
    </AuthLayout>
  )
}
